// app/components/privacy-graph-scrolly/elements/classification-chip.tsx

import { CLASSIFICATION_CHIP } from "../graph-layout";
import { SVG_COLORS } from "@/lib/svg-colors";

interface Props {
  x: number;
  y: number;
  label: string;
}

const PADDING_X = 10;
const HEIGHT = 22;
const CHAR_W = 7.2;       // Geist Mono at 11px, ~7.2px advance with 0.04em tracking.

export function ClassificationChip({ x, y, label }: Props) {
  const w = label.length * CHAR_W + PADDING_X * 2;
  return (
    <g transform={`translate(${x}, ${y})`}>
      <rect
        width={w}
        height={HEIGHT}
        rx={4}
        fill={SVG_COLORS.surface}
        stroke={CLASSIFICATION_CHIP.stroke}
        strokeWidth={1}
      />
      <text
        x={PADDING_X}
        y={HEIGHT / 2 + 4}
        fontSize={11}
        letterSpacing="0.04em"
        fill={CLASSIFICATION_CHIP.text}
        fontFamily="var(--font-mono, ui-monospace, SFMono-Regular, monospace)"
      >
        {label}
      </text>
    </g>
  );
}

export function classificationChipWidth(label: string): number {
  return label.length * CHAR_W + PADDING_X * 2;
}
